import { MediaQuery } from "svelte/reactivity";

const DEFAULT_MOBILE_BREAKPOINT = 768;

export class IsMobile extends MediaQuery {
	constructor(breakpoint: number = DEFAULT_MOBILE_BREAKPOINT) {
		super(`(max-width: ${breakpoint - 1}px)`);
	}

	/**
	 * Alias for call sites that read `.value`. A getter, not `$derived`: `current` is already
	 * reactive through `createSubscriber`, so wrapping it in a derived bought nothing and
	 * added a class field the upstream shadcn-svelte hook does not have.
	 */
	get value(): boolean {
		return this.current;
	}
}

// Export a default instance for convenience
export const isMobile = new IsMobile();
